import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import HeroSection from "../components/Landing/HeroSection";
import AiAssistStrip from "../components/Landing/AiAssistStrip";
import SeasonList from "../components/Landing/SeasonList";
import FeatureFlyers from "../components/Landing/FeatureFlyers";
import PricingTiers from "../components/Landing/PricingTiers";
import HomeRunCta from "../components/Landing/HomeRunCta";
import SEOHead from "../components/SEO/SEOHead";
import { generateWebsiteStructuredData } from "../components/SEO/StructuredData";
import { fetchHomepageSeason } from "../utils/homepageSeason";
import { HOME_DESCRIPTION, HOME_TITLE } from "../utility/aiAssistCopy";

const emptySeason = {
  season: [],
  upcoming: [],
  recent: [],
  live: null,
  next: null,
  completed: [],
  heroState: "off",
  boardTournament: null,
  boardRows: [],
  prizeFund: null,
  upcomingCount: 0,
};

const LandingPage = () => {
  const [homepage, setHomepage] = useState(emptySeason);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchHomepageSeason(supabase);
        setHomepage(data);
      } catch (error) {
        console.error("Error fetching homepage season:", error);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return (
    <>
      <SEOHead
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        keywords={[
          "AI bowling tournament software",
          "bowling tournament AI assist",
          "bowling tournament signups",
          "bowling tournament scoring",
          "bowling tournament payouts",
        ]}
        canonicalUrl="/"
        ogType="website"
        structuredData={generateWebsiteStructuredData()}
        additionalMeta={[
          { name: "author", content: "Bowling Tournament App" },
          {
            name: "viewport",
            content: "width=device-width, initial-scale=1.0",
          },
          { name: "theme-color", content: "#242424" },
        ]}
      />
      <div className="min-h-screen bg-brand-cream">
        <HeroSection
          live={homepage.heroState === "live"}
          boardTournament={homepage.boardTournament}
          boardRows={homepage.boardRows}
          prizeFund={homepage.prizeFund}
          loading={loading}
        />
        <SeasonList upcoming={homepage.upcoming} recent={homepage.recent} />
        <AiAssistStrip />
        <FeatureFlyers />
        <PricingTiers />
        <HomeRunCta />
      </div>
    </>
  );
};

export default LandingPage;
